import * as lead from '../types/lead'

export const initialState = {
    loading: false,
    modalCNPJ: false,
    modalLead: false,
    newCompany: true,
    modalExistingProduct: false,
    modalMaintenanceProduct: false,
    modalRegistrationIrregularity: false,
    modalPollingError: false,
    removedProducts: [],
    leadData: {
        cnpj: '',
        name: '',
        email: '',
        phone: ''
    },
    apiErrorCnpj: false
}

export const leadReducer = (state = initialState, action = { type: '' }) => {
    switch (action.type) {
        case lead.OPEN_MODAL_CNPJ:
            return {
                ...state,
                modalCNPJ: true
            }
        case lead.CLOSE_MODAL_CNPJ:
            return {
                ...state,
                modalCNPJ: false
            }
        case lead.OPEN_MODAL_LEAD:
            return {
                ...state,
                modalLead: true
            }
        case lead.CLOSE_MODAL_LEAD:
            return {
                ...state,
                modalLead: false
            }
        case lead.OPEN_MODAL_PRODUCT_EXISTING:
            return {
                ...state,
                modalExistingProduct: true
            }
        case lead.CLOSE_MODAL_PRODUCT_EXISTING:
            return {
                ...state,
                modalExistingProduct: false
            }
        case lead.OPEN_MODAL_MAINTENANCE_PRODUCT:
            return {
                ...state,
                modalMaintenanceProduct: true
            }
        case lead.CLOSE_MODAL_MAINTENANCE_PRODUCT:
            return {
                ...state,
                modalMaintenanceProduct: false
            }
        case lead.OPEN_MODAL_REGISTRATION_IRREGULARITY:
            return {
                ...state,
                modalRegistrationIrregularity: true,
                removedProducts: action.removedProducts
            }
        case lead.CLOSE_MODAL_REGISTRATION_IRREGULARITY:
            return {
                ...state,
                modalRegistrationIrregularity: false
            }
        case lead.OPEN_MODAL_POLLING_ERROR:
            return {
                ...state,
                modalPollingError: true
            }
        case lead.CLOSE_MODAL_POLLING_ERROR:
            return {
                ...state,
                modalPollingError: false
            }
        case lead.SET_NEW_COMPANY:
            return {
                ...state,
                newCompany: true
            }
        case lead.SET_OLD_COMPANY:
            return {
                ...state,
                newCompany: false
            }
        case lead.CLOSE_ALL_MODAL:
            return initialState
        case lead.SET_CNPJ_LEAD:
            return {
                ...state,
                leadData: {
                    ...state.leadData,
                    cnpj: action.value
                }
            }
        case lead.SET_LOADING:
            return {
                ...state,
                loading: true
            }
        case lead.REMOVE_LOADING:
            return {
                ...state,
                loading: false
            }
        case lead.UPDATE_LEAD:
            return {
                ...state,
                leadData: {
                    ...state.leadData,
                    name: action.name,
                    email: action.email,
                    phone: action.phone
                }
            }
        case lead.SET_CNPJ_ERROR:
            return {
                ...state,
                apiErrorCnpj: true
            }
        case lead.REMOVE_CNPJ_ERROR:
            return {
                ...state,
                apiErrorCnpj: false
            }
        case lead.RESET:
            return initialState
        default:
            return state
    }
}
